var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === 3
    ? _c(
        "yxt-select",
        {
          staticClass: "width-percent-100-i",
          attrs: {
            placeholder: _vm.$t("pc_biz_lbl_selectthings" /* 请选择 */, [
              _vm.config.attrName,
            ]),
            disabled: _vm.disabled,
            clearable: "",
          },
          model: {
            value: _vm.attr.value,
            callback: function ($$v) {
              _vm.$set(_vm.attr, "value", $$v)
            },
            expression: "attr.value",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("yxt-option", {
            key: item,
            attrs: { label: item, value: item },
          })
        }),
        1
      )
    : _vm.type === 2
    ? _c("yxt-date-picker", {
        staticClass: "width-percent-100-i",
        attrs: {
          type: "date",
          disabled: _vm.disabled,
          "value-format": "yyyy-MM-dd",
          format: _vm.$t(
            "pc_kng_custom_lbl_yyyy_year_mm_month_dd_day" /** yyyy 年 MM 月 dd 日 */
          ),
          placeholder: _vm.$t("pc_biz_lbl_selectthings" /* 请选择 */, [
            _vm.config.attrName,
          ]),
          "picker-options": {
            disabledDate: _vm.disabledDate,
          },
        },
        model: {
          value: _vm.attr.value,
          callback: function ($$v) {
            _vm.$set(_vm.attr, "value", $$v)
          },
          expression: "attr.value",
        },
      })
    : _vm.type === 1
    ? _c("yxt-input", {
        staticClass: "width-percent-100-i",
        attrs: {
          placeholder: _vm.$t("pc_biz_lbl_inputthings" /* 请填写 */, [
            _vm.config.attrName,
          ]),
          disabled: _vm.disabled,
          minlength: _vm.rangeMin,
          maxlength: _vm.rangeMax,
        },
        model: {
          value: _vm.attr.value,
          callback: function ($$v) {
            _vm.$set(_vm.attr, "value", $$v)
          },
          expression: "attr.value",
        },
      })
    : _c("yxt-input-number", {
        staticClass: "width-percent-100-i",
        attrs: {
          placeholder: _vm.$t("pc_biz_lbl_inputthings" /* 请填写 */, [
            _vm.config.attrName,
          ]),
          min: _vm.rangeMin,
          max: _vm.rangeMax,
          disabled: _vm.disabled,
        },
        model: {
          value: _vm.attr.value,
          callback: function ($$v) {
            _vm.$set(_vm.attr, "value", $$v)
          },
          expression: "attr.value",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }